import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IPostRequestResetPasswordResponseApi } from "@interfaces/IPostRequestResetPasswordResponseApi.ts"
import { IPostRequestResetPasswordResponseCli } from "@interfaces/IPostRequestResetPasswordResponseCli.ts"

export const PostRequestResetPasswordAdapter = (
	response: IApiResponse<IPostRequestResetPasswordResponseApi>
): IPostRequestResetPasswordResponseCli => response?.data
